import { Component, OnInit, Input, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
import { Router } from '@angular/router';
import { environment } from '../../../../environments/environment'
import { ToastService } from '../../../shared/providers/toast.service'
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ValidationService } from '../../../shared/providers/validation.service';
import { OfferService } from '../../../shared/providers/offer.service';
import { CommonService } from '../../../shared/providers/common.service';
import { OfferDetailExpenseModel } from '../../../shared/models/OfferDetailExpenseModel';
import { ILookUp } from '../../../shared/models/LookUpOutputModel';

@Component({
    selector: 'app-offer-expense-list',
    templateUrl: './offer-expense-list.component.html',
})
export class OfferExpenseListComponent implements OnInit {

    @Input() inputOfferGuid: string = "";
    labelForAddOrEdit: string = "";
    offerDetailExpenseModel = {} as OfferDetailExpenseModel;
    offerDetailExpenseModelList: OfferDetailExpenseModel[];
    totalAmount: number;
    disabledAddOrEditBtn: boolean = false;
    modalRef: BsModalRef;
    amountValid: boolean = false;
    categoryValid: boolean = false;
    paidStatusValid: boolean = false;
    expenseDateValid: boolean = false;
    IsValid: boolean = false;
    paidStatusList: ILookUp[];
    isSubmitted = false;

    constructor(private http: HttpClient, private authService: AuthenticationService,
        private router: Router, private modalService: BsModalService, private _toastService: ToastService,
        private validationService: ValidationService, private _commonService: CommonService,
        private offerService: OfferService) { }

    categoryList = [];
    ngOnInit() {
        this.totalAmount = 0;
        this._commonService.getLookupsByTypeId(28).subscribe(response => {
            this.paidStatusList = response.map(o => {
                return {
                    id: o.Id, description: o.Description
                };
            });
        });

        this._commonService.getExpenseCategory().subscribe(response => {
            this.categoryList = response.map(o => {
                return {
                    id: o.Id, name: o.CategoryName
                };
            });
        });

        this.loadData();
    }

    loadData() {
        if (this.inputOfferGuid != null && this.inputOfferGuid != "") {
            this.offerService.getOfferExpenseList(this.inputOfferGuid).subscribe(response => {
                this.offerDetailExpenseModelList = response;
                this.totalAmount = 0;
                this.offerDetailExpenseModelList.forEach(item => {
                    this.totalAmount = this.totalAmount + item.Amount;
                    item.ExpenseDate = this.validationService.convertUTCDateToLocalDate(item.ExpenseDate);
                });
            });
        }
    }

    openModalForAddOrEdit(template: TemplateRef<any>, classes, id: number, data: any) {

        if (data == null) {
            this.labelForAddOrEdit = "Add Expense";
            this.offerDetailExpenseModel.LeadExpenseId = id;
            this.offerDetailExpenseModel.Amount = null;
            this.offerDetailExpenseModel.Description = null;
            this.offerDetailExpenseModel.CategoryId = 0;
            this.offerDetailExpenseModel.PaidStatusId = 0;
            this.offerDetailExpenseModel.ExpenseDate = null;
        }
        else {
            this.labelForAddOrEdit = "Edit Expense";
            this.offerDetailExpenseModel.LeadExpenseId = id;
            //// this.offerDetailExpenseModel.Amount = data.Amount;            
            this.offerDetailExpenseModel.Amount = data.Amount;
            this.offerDetailExpenseModel.Description = data.Description;
            this.offerDetailExpenseModel.CategoryId = data.CategoryId;
            this.offerDetailExpenseModel.PaidStatusId = data.PaidStatusId;
            this.offerDetailExpenseModel.ExpenseDate = data.ExpenseDate;
        }

        this.offerDetailExpenseModel.LeadDetailGuid = this.inputOfferGuid;

        this.amountValid = false;
        this.categoryValid = false;
        this.paidStatusValid = false;
        this.expenseDateValid = false;
        this.IsValid = false;
        this.modalRef = this.modalService.show(template, { class: classes });
        this.disabledAddOrEditBtn = false;

    }

    expenseValidation() {
        
        this.IsValid = true;

        if (this.validationService.IsinValid(this.offerDetailExpenseModel.Amount)) {
            this.amountValid = true;
            this.IsValid = false;
        }
        else {
            this.amountValid = false;
        }

        if (this.validationService.isInvalidDropDown(this.offerDetailExpenseModel.CategoryId)) {
            this.categoryValid = true;
            this.IsValid = false;
        }
        else {
            this.categoryValid = false;
        }


        if (this.validationService.isInvalidDropDown(this.offerDetailExpenseModel.PaidStatusId)) {
            this.paidStatusValid = true;
            this.IsValid = false;
        }
        else {
            this.paidStatusValid = false;
        }

        if (this.validationService.IsinValid(this.offerDetailExpenseModel.ExpenseDate)) {
            this.expenseDateValid = true;
            this.IsValid = false;
        }
        else {
            this.expenseDateValid = false;
        }

        if (this.categoryValid || this.amountValid || this.paidStatusValid || this.expenseDateValid) {
            this.IsValid = false;
        }

        return this.IsValid;
    }

    amountValidation() {
        if (this.validationService.IsinValid(this.offerDetailExpenseModel.Amount)) {
            this.amountValid = true;
            this.IsValid = false;
        }
        else {
            this.amountValid = false;
        }
    }

    categoryValidation() {
        if (this.validationService.isInvalidDropDown(this.offerDetailExpenseModel.CategoryId)) {
            this.categoryValid = true;
            this.IsValid = false;
        }
        else {
            this.categoryValid = false;
        }
    }

    paidStatusValidation() {
        if (this.validationService.isInvalidDropDown(this.offerDetailExpenseModel.PaidStatusId)) {
            this.paidStatusValid = true;
            this.IsValid = false;
        }
        else {
            this.paidStatusValid = false;
        }
    }

    expenseDateValidation() {
        if (this.validationService.IsinValid(this.offerDetailExpenseModel.ExpenseDate)) {
            this.expenseDateValid = true;
            this.IsValid = false;
        }
        else {
            this.expenseDateValid = false;
        }
    }

    saveOfferExpense() {
      this.disabledAddOrEditBtn = true;
      this.isSubmitted = true;
        if (this.expenseValidation()) {
            this.offerDetailExpenseModel.ExpenseDate = this.validationService.utcify(this.offerDetailExpenseModel.ExpenseDate);
            this.offerService.saveOfferExpense(this.offerDetailExpenseModel).subscribe(response => {
                if (response) {
                    this._toastService.addToast({ title: 'Success', msg: 'Expense saved successfully', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
                    this.disabledAddOrEditBtn = true;
                    document.getElementById("closeModal").click();
                    this.loadData();
                }
                else {
                    this._toastService.addToast({ title: 'Error Occurred', msg: 'Please check your input data', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
                    setTimeout(() => {
                        this.disabledAddOrEditBtn = false;
                    }, 2000);
                }
            });
        }
        else {
            this._toastService.addToast({ title: 'Error Occurred', msg: 'Please fill the mandatory fields', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })

            setTimeout(() => {
                this.disabledAddOrEditBtn = false;
            }, 2000);
        }
    }
}
